import { rootReducer } from '..';
import { SavedCreditCardsType } from '../../pages/PaymentPage/type';

type RootState = ReturnType<typeof rootReducer>;

export const savedCreditCardsSelector = (state: RootState): SavedCreditCardsType[] | null => state.savedCreditCards;

export const uniqSavedCreditCardsSelector = (state: RootState): SavedCreditCardsType[] | null => {
  const defaultCard = state?.savedCreditCards?.find((card) => card.isDefaultPaymentMethod);
  const uniqueCardsMap = new Map();

  state?.savedCreditCards?.forEach((card) => {
    const uniqueKey = `${card.last4}-${card.exp_month}-${card.exp_year}`;

    if (!uniqueCardsMap.has(uniqueKey) || card.isDefaultPaymentMethod) {
      uniqueCardsMap.set(uniqueKey, card);
    }
  });

  if (defaultCard && !uniqueCardsMap.has(`${defaultCard.last4}-${defaultCard.exp_month}-${defaultCard.exp_year}`)) {
    uniqueCardsMap.set(`${defaultCard.last4}-${defaultCard.exp_month}-${defaultCard.exp_year}`, defaultCard);
  }

  return Array.from(uniqueCardsMap.values());
};
